import { Package } from '@revenuecat/purchases-js';

export const ENTITLEMENT_NAME = 'Full Access';

export interface ProductPrice {
  amount: number;
  amountMicros?: number;
  /**
   * The currency code for the product price, e.g., 'USD', 'CAD'.
   */
  currency: string;
  /**
   * Formatted price string for display purposes. Includes the currency symbol and is localized.
   */
  formattedPrice: string;
}

export interface PeriodUnit {
  number: number;
  unit: string;
}

export interface PeriodDuration {
  /**
   * Subscription period, specified in ISO 8601 format. For example,
   * P1W equates to one week, P1M equates to one month,
   * P3M equates to three months, P6M equates to six months,
   * and P1Y equates to one year.
   */
  periodDuration: string;
  period: PeriodUnit;
  cycleCount: number;
  pricePerWeek?: ProductPrice | null;
  pricePerMonth?: ProductPrice | null;
  pricePerYear?: ProductPrice | null;
}

export interface Product {
  identifier: string;
  /**
   * Use `title` instead of `displayName` for consistency with other models.
   */
  displayName?: string;
  title: string;
  description: string;
  currentPrice: ProductPrice;
  subscriptionPeriod: PeriodDuration | null;
  trial: PeriodDuration | null;
  /**
   * The RevenueCat Package associated with this product. This will be sent when purchasing the product.
   */
  rcPackage?: Package;
}

export enum PeriodUnitEnum {
  'month' = 'mo',
  'year' = 'yr',
  'week' = 'wk',
}
